// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__14kH7","file":"styles_file__136e0"};